import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, vModelSelect as _vModelSelect, vModelText as _vModelText, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6d79f70b")

_pushScopeId("data-v-6d79f70b")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("個人データを編集")
const _hoisted_2 = {
  key: 0,
  class: "w-3/4 p-3 mx-auto mb-6 flex items-center bg-red-100 rounded-md"
}
const _hoisted_3 = { class: "text-red-500" }
const _hoisted_4 = { class: "ml-2 font-medium text-sm text-gray-700" }
const _hoisted_5 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_6 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_7 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_8 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_9 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_10 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_11 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_12 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_13 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_14 = {
  key: 1,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_15 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " この生徒のプロンプト作成を禁止する ", -1)
const _hoisted_17 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_18 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " この生徒から先生へのメッセージ送信を許可する ", -1)
const _hoisted_20 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_21 = {
  key: 2,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " スクールAI 利用回数制限（個別設定） ", -1)
const _hoisted_23 = { class: "p-4 bg-primary-100 rounded-md mb-4" }
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "text-sm font-medium text-gray-700 mb-2" }, " 現在のスクールレベル制限（生徒向け・参考） ", -1)
const _hoisted_25 = { class: "text-sm text-gray-700" }
const _hoisted_26 = { class: "text-sm text-gray-700 mt-1" }
const _hoisted_27 = {
  key: 1,
  class: "text-sm text-gray-700"
}
const _hoisted_28 = { class: "p-4 bg-primary-100 rounded-md" }
const _hoisted_29 = { class: "pb-4 mb-4 border-b border-primary-200" }
const _hoisted_30 = { class: "flex items-center mb-3" }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "pl-2 cursor-pointer" }, "個別制限を有効にする", -1)
const _hoisted_32 = { class: "text-xs text-gray-500" }
const _hoisted_33 = { class: "space-y-3" }
const _hoisted_34 = { class: "px-4 py-4 bg-white rounded-md border border-gray-200" }
const _hoisted_35 = {
  key: 0,
  class: "mt-3 inline-flex items-center rounded-full bg-primary-50 px-3 py-1 text-xs text-gray-600"
}
const _hoisted_36 = { class: "px-4 py-4 bg-white rounded-md border border-gray-200" }
const _hoisted_37 = {
  key: 0,
  class: "mt-3 inline-flex items-center rounded-full bg-primary-50 px-3 py-1 text-xs text-gray-600"
}
const _hoisted_38 = { class: "px-4 py-4 bg-white rounded-md border border-gray-200" }
const _hoisted_39 = /*#__PURE__*/_createVNode("p", { class: "text-xs text-gray-500 mt-2" }, " 未設定の場合は送信回数上限の20%以下で警告表示します。 ", -1)
const _hoisted_40 = {
  key: 0,
  class: "mt-3 inline-flex items-center rounded-full bg-primary-50 px-3 py-1 text-xs text-gray-600"
}
const _hoisted_41 = { class: "px-4 py-4 bg-white rounded-md border border-gray-200" }
const _hoisted_42 = { class: "flex items-center" }
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { class: "pl-2 cursor-pointer" }, " システムプロンプトもカウント対象にする ", -1)
const _hoisted_44 = {
  key: 0,
  class: "mt-3 inline-flex items-center rounded-full bg-primary-50 px-3 py-1 text-xs text-gray-600"
}
const _hoisted_45 = { class: "px-4 py-4 bg-white rounded-md border border-gray-200" }
const _hoisted_46 = /*#__PURE__*/_createVNode("p", { class: "text-xs text-gray-500 mt-2" }, " 未設定の場合の有効期限は無期限です。 ", -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("p", { class: "text-xs text-gray-500 mt-1" }, " 有効期限内に送信されたチャットのみ、この制限の送信回数としてカウントされます。 ", -1)
const _hoisted_48 = {
  key: 0,
  class: "mt-3 inline-flex items-center rounded-full bg-primary-50 px-3 py-1 text-xs text-gray-600"
}
const _hoisted_49 = { class: "flex flex-col items-center w-3/4 mx-auto" }
const _hoisted_50 = /*#__PURE__*/_createVNode("label", {
  for: "classSchedules",
  class: "leading-7 text-sm text-gray-600 w-full"
}, [
  /*#__PURE__*/_createTextVNode(" 保護者向け入退室通知受信メール "),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-400" }, "※登録前に保護者に確認が必要です")
], -1)
const _hoisted_51 = { class: "flex w-full h-full" }
const _hoisted_52 = /*#__PURE__*/_createVNode("span", null, "削除", -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "4",
  class: "w-4 h-4 mr-2",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M12 6v6m0 0v6m0-6h6m-6 0H6" })
], -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("span", null, "メールアドレスを追加する", -1)
const _hoisted_55 = { class: "flex flex-col items-center w-3/4 mx-auto" }
const _hoisted_56 = /*#__PURE__*/_createVNode("label", {
  for: "classSchedules",
  class: "leading-7 text-sm text-gray-600 w-full"
}, " 毎週の授業日時 ", -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("span", null, "削除", -1)
const _hoisted_58 = { class: "w-full flex items-end" }
const _hoisted_59 = { class: "w-1/4" }
const _hoisted_60 = /*#__PURE__*/_createVNode("label", {
  for: "email",
  class: "leading-7 text-sm text-gray-500"
}, " 曜日 ", -1)
const _hoisted_61 = { class: "relative transition-all duration-300 hover:text-primary-500" }
const _hoisted_62 = /*#__PURE__*/_createVNode("option", { disabled: "" }, "授業曜日を選択", -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("span", { class: "absolute right-2 top-0 h-full w-6 text-center pointer-events-none flex items-center justify-center text-primary-500" }, [
  /*#__PURE__*/_createVNode("svg", {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    class: "w-4 h-4",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("path", { d: "M6 9l6 6 6-6" })
  ])
], -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_65 = { class: "w-1/4" }
const _hoisted_66 = /*#__PURE__*/_createVNode("label", {
  for: "email",
  class: "leading-7 text-sm text-gray-500"
}, " 開始 ", -1)
const _hoisted_67 = /*#__PURE__*/_createVNode("div", { class: "w-1/6 text-center py-2" }, "〜", -1)
const _hoisted_68 = { class: "w-1/4" }
const _hoisted_69 = /*#__PURE__*/_createVNode("label", {
  for: "email",
  class: "leading-7 text-sm text-gray-500"
}, " 終了 ", -1)
const _hoisted_70 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "4",
  class: "w-4 h-4 mr-2",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M12 6v6m0 0v6m0-6h6m-6 0H6" })
], -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("span", null, "授業日時を追加", -1)
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" 生徒削除 ")
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" 休会解除 ")
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" 休会に変更 ")
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" 変更を保存 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_select_box = _resolveComponent("m-select-box")
  const _component_m_text_area = _resolveComponent("m-text-area")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_multi_select_box = _resolveComponent("m-multi-select-box")
  const _component_MBaseModal = _resolveComponent("MBaseModal")
  const _component_MSQandaRegisterModal = _resolveComponent("MSQandaRegisterModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_MBaseModal, { onClose: _ctx.close }, {
      title: _withId(() => [
        _hoisted_1
      ]),
      body: _withId(() => [
        (_ctx.inRecess)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_m_icon, {
                  type: "warning",
                  size: "6"
                })
              ]),
              _createVNode("p", _hoisted_4, _toDisplayString(_ctx.recessStartDay) + " から休会中です。休会から復帰させたい場合は入力ウィンドウ右下の「休会解除」ボタンを押してください ", 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_m_text_field, {
            label: "ユーザーネーム",
            name: "name",
            type: "text",
            placeholder: "例）田中（た） ※学習室などで、他ユーザに表示される可能性があります",
            value: _ctx.name,
            invalid: !_ctx.validName,
            "invalid-message": "ユーザーネームは入力必須です",
            entered: "",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event))
          }, null, 8, ["value", "invalid"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_m_select_box, {
            key: "ref.id",
            label: "教室",
            name: "classroom",
            placeholder: "所属教室を選択",
            options: _ctx.classRooms,
            value: _ctx.selectClassroomId,
            "value-key": "ref.id",
            "text-key": "data.name",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectClassroomId = $event))
          }, null, 8, ["options", "value"])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_m_text_field, {
            label: "生徒ID (編集不可)",
            name: "studentId",
            type: "text",
            value: _ctx.studentId,
            disabled: ""
          }, null, 8, ["value"])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_m_text_field, {
            label: "生徒ログインID (重複不可)",
            name: "validstudentLoginId",
            type: "text",
            placeholder: "半角英数字5文字以上",
            value: _ctx.studentLoginId,
            invalid: !_ctx.validstudentLoginId,
            "invalid-message": "ログインIDは半角英数字5文字以上で入力してください。また他の生徒と同じIDは使用できません。",
            entered: "",
            onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.studentLoginId = $event))
          }, null, 8, ["value", "invalid"])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_m_text_field, {
            label: "ログインパスワード",
            name: "password",
            type: "text",
            placeholder: "半角英数字記号8文字以上",
            value: _ctx.password,
            invalid: !_ctx.validPassword,
            "invalid-message": "パスワードは8〜64文字で、英字と、数字または記号を含めてください（スペースと全角文字は使えません）",
            entered: "",
            onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.password = $event))
          }, null, 8, ["value", "invalid"])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_m_select_box, {
            label: "学年",
            name: "grade",
            placeholder: "生徒の学年を選択",
            options: _ctx.grades,
            value: _ctx.selectGrade,
            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectGrade = $event))
          }, null, 8, ["options", "value"])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_m_text_area, {
            label: "特徴",
            name: "characteristics",
            placeholder: "生徒の特徴を記述してください（任意）",
            value: _ctx.characteristic,
            onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.characteristic = $event))
          }, null, 8, ["value"])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode(_component_m_text_field, {
            label: "Googleアカウント",
            name: "gmail",
            placeholder: "生徒のGmailを入力してください（任意）",
            value: _ctx.gmail,
            invalid: !_ctx.validGmail,
            "invalid-message": "メールアドレスが正しくありません",
            entered: "",
            onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.gmail = $event))
          }, null, 8, ["value", "invalid"])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_m_text_field, {
            label: "Microsoftアカウント",
            name: "microsoftEmail",
            placeholder: "生徒のMicrosoftメールを入力してください（任意）",
            value: _ctx.microsoftEmail,
            invalid: !_ctx.validMicrosoftEmail,
            "invalid-message": "メールアドレスが正しくありません",
            entered: "",
            onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.microsoftEmail = $event))
          }, null, 8, ["value", "invalid"])
        ]),
        (_ctx.canUseLearningCard)
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              _createVNode(_component_m_text_field, {
                label: "心拍デバイス",
                name: "polarDeviceId",
                placeholder: "生徒のデバイスIDを入力してください（任意）",
                value: _ctx.polarDeviceId,
                onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.polarDeviceId = $event))
              }, null, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode("div", _hoisted_17, [
            _withDirectives(_createVNode("input", {
              id: "allow-students-to-create-prompts",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.isPromptCreationDisabled = $event)),
              type: "checkbox",
              name: "allow-students-to-create-prompts",
              class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
            }, null, 512), [
              [_vModelCheckbox, _ctx.isPromptCreationDisabled]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode("div", _hoisted_20, [
            _withDirectives(_createVNode("input", {
              id: "allow-student-message-sending",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.isStudentMessageSendingAllowed = $event)),
              type: "checkbox",
              name: "allow-student-message-sending",
              class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
            }, null, 512), [
              [_vModelCheckbox, _ctx.isStudentMessageSendingAllowed]
            ])
          ])
        ]),
        (_ctx.canShowStudentChatMessageIndividualLimitSection)
          ? (_openBlock(), _createBlock("div", _hoisted_21, [
              _hoisted_22,
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                (_ctx.activeSchoolChatMessageUsageLimit)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createVNode("p", _hoisted_25, _toDisplayString(_ctx.schoolChatMessageUsageReferenceLine1), 1),
                      _createVNode("p", _hoisted_26, _toDisplayString(_ctx.schoolChatMessageUsageReferenceLine2), 1)
                    ], 64))
                  : (_openBlock(), _createBlock("p", _hoisted_27, " 生徒向けスクールレベル制限: 未設定 "))
              ]),
              _createVNode("div", _hoisted_28, [
                _createVNode("div", _hoisted_29, [
                  _createVNode("label", _hoisted_30, [
                    _withDirectives(_createVNode("input", {
                      id: "student-chat-message-usage-limit-enabled",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.studentChatMessageUsageLimitConfig.enabled = $event)),
                      type: "checkbox",
                      class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded",
                      onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleStudentChatMessageUsageLimitEnabledChange && _ctx.handleStudentChatMessageUsageLimitEnabledChange(...args)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.studentChatMessageUsageLimitConfig.enabled]
                    ]),
                    _hoisted_31
                  ]),
                  _createVNode("p", _hoisted_32, _toDisplayString(_ctx.studentChatMessageUsageLimitConfig.enabled
                  ? "この生徒にはスクールレベルの制限ではなく、以下の個別設定が適用されます。"
                  : "スクールレベルの制限が適用されます。"), 1)
                ]),
                _createVNode("div", _hoisted_33, [
                  _createVNode("div", _hoisted_34, [
                    _createVNode(_component_m_select_box, {
                      label: "利用制限の期間",
                      name: "student-chat-message-usage-limit-period",
                      placeholder: "利用制限の期間を選択",
                      options: _ctx.usageLimitPeriods,
                      value: _ctx.studentChatMessageUsageLimitConfig.period,
                      "value-key": "value",
                      "text-key": "label",
                      disabled: !_ctx.studentChatMessageUsageLimitConfig.enabled,
                      onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.studentChatMessageUsageLimitConfig.period = $event))
                    }, null, 8, ["options", "value", "disabled"]),
                    (_ctx.activeSchoolChatMessageUsageLimit)
                      ? (_openBlock(), _createBlock("p", _hoisted_35, " スクールレベル: " + _toDisplayString(_ctx.schoolLevelChatMessagePeriodLabel), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_36, [
                    _createVNode(_component_m_text_field, {
                      label: "送信回数上限",
                      name: "student-chat-message-usage-limit",
                      type: "number",
                      placeholder: "1以上の半角数字",
                      min: "1",
                      step: "1",
                      value: 
                  _ctx.studentChatMessageUsageLimitConfig.limit !== null
                    ? _ctx.studentChatMessageUsageLimitConfig.limit
                    : ''
                ,
                      disabled: !_ctx.studentChatMessageUsageLimitConfig.enabled,
                      invalid: !_ctx.validStudentChatMessageUsageLimit,
                      "invalid-message": "有効時は1以上の整数を入力してください",
                      onInput: _ctx.handleStudentChatMessageLimitInput
                    }, null, 8, ["value", "disabled", "invalid", "onInput"]),
                    (_ctx.activeSchoolChatMessageUsageLimit)
                      ? (_openBlock(), _createBlock("p", _hoisted_37, " スクールレベル: " + _toDisplayString(_ctx.schoolLevelChatMessageLimitLabel), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_38, [
                    _createVNode(_component_m_text_field, {
                      label: "警告表示の残数",
                      name: "student-chat-message-warning-threshold",
                      type: "number",
                      placeholder: "未設定の場合は上限の20%",
                      min: "0",
                      step: "1",
                      value: 
                  _ctx.studentChatMessageUsageLimitConfig.warningThreshold !==
                    null &&
                  _ctx.studentChatMessageUsageLimitConfig.warningThreshold !==
                    undefined
                    ? _ctx.studentChatMessageUsageLimitConfig.warningThreshold
                    : ''
                ,
                      disabled: !_ctx.studentChatMessageUsageLimitConfig.enabled,
                      invalid: !_ctx.validStudentChatMessageWarningThreshold,
                      "invalid-message": "有効時は0以上かつ送信回数上限以下の整数を入力してください",
                      onInput: _ctx.handleStudentChatMessageWarningThresholdInput
                    }, null, 8, ["value", "disabled", "invalid", "onInput"]),
                    _hoisted_39,
                    (_ctx.activeSchoolChatMessageUsageLimit)
                      ? (_openBlock(), _createBlock("p", _hoisted_40, " スクールレベル: " + _toDisplayString(_ctx.schoolLevelChatMessageWarningThresholdLabel), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_41, [
                    _createVNode("label", _hoisted_42, [
                      _withDirectives(_createVNode("input", {
                        id: "student-chat-message-count-system-prompt",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.studentChatMessageUsageLimitConfig.countSystemPrompt = $event)),
                        type: "checkbox",
                        class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded",
                        disabled: !_ctx.studentChatMessageUsageLimitConfig.enabled
                      }, null, 8, ["disabled"]), [
                        [_vModelCheckbox, _ctx.studentChatMessageUsageLimitConfig.countSystemPrompt]
                      ]),
                      _hoisted_43
                    ]),
                    (_ctx.activeSchoolChatMessageUsageLimit)
                      ? (_openBlock(), _createBlock("p", _hoisted_44, " スクールレベル: " + _toDisplayString(_ctx.schoolLevelChatMessageCountSystemPromptLabel), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_45, [
                    _createVNode(_component_m_text_field, {
                      label: "有効期限",
                      name: "student-chat-message-usage-limit-expires-at",
                      type: "date",
                      placeholder: "未設定の場合は無期限",
                      value: _ctx.studentChatMessageLimitExpiresAtDate,
                      disabled: !_ctx.studentChatMessageUsageLimitConfig.enabled,
                      onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.studentChatMessageLimitExpiresAtDate = $event))
                    }, null, 8, ["value", "disabled"]),
                    _hoisted_46,
                    _hoisted_47,
                    (_ctx.activeSchoolChatMessageUsageLimit)
                      ? (_openBlock(), _createBlock("p", _hoisted_48, " スクールレベル: " + _toDisplayString(_ctx.schoolLevelChatMessageExpiresAtLabel), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_49, [
          _hoisted_50,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.emailReceivers, (emailReceiver, i) => {
            return (_openBlock(), _createBlock("div", {
              key: i,
              class: "w-full flex flex-col items-center rounded-md border-2 border-gray-200 px-3 py-2 mb-4"
            }, [
              _createVNode("div", _hoisted_51, [
                _createVNode(_component_m_text_field, {
                  modelValue: emailReceiver.email,
                  "onUpdate:modelValue": ($event: any) => (emailReceiver.email = $event),
                  class: "flex-1",
                  label: "メールアドレス",
                  name: "email",
                  type: "email",
                  placeholder: "example@mingaku.net",
                  invalid: !_ctx.validEmail(emailReceiver.email),
                  "invalid-message": "メールアドレスが正しくありません",
                  entered: _ctx.enteredEmail[i],
                  value: emailReceiver.email,
                  onInput: ($event: any) => (emailReceiver.email = $event),
                  onEnter: ($event: any) => (_ctx.enteredEmail[i] = true)
                }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid", "entered", "value", "onInput", "onEnter"]),
                _createVNode(_component_m_button, {
                  color: "primary-500 ml-3 h-7 mt-9",
                  "hover-color": "primary-600",
                  onClick: ($event: any) => (_ctx.deleteEmailReceiver(i))
                }, {
                  default: _withId(() => [
                    _createVNode(_component_m_icon, { type: "trash" }),
                    _hoisted_52
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 128)),
          _createVNode("div", {
            class: "flex items-center text-sm rounded-md text-gray-400 font-medium px-4 py-2 border-2 border-gray-200 cursor-pointer transition-colors duration-300 hover:text-primary-500 hover:border-primary-500",
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.addEmailReceiver && _ctx.addEmailReceiver(...args)))
          }, [
            _hoisted_53,
            _hoisted_54
          ])
        ]),
        _createVNode("div", _hoisted_55, [
          _hoisted_56,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.classSchedules, (schedule, i) => {
            return (_openBlock(), _createBlock("div", {
              key: i,
              class: "w-full flex flex-col items-center rounded-md border-2 border-gray-200 px-3 py-2 mb-4"
            }, [
              _createVNode(_component_m_button, {
                color: "primary-500",
                "hover-color": "primary-600",
                size: "sm",
                onClick: ($event: any) => (_ctx.deleteSchedule(i))
              }, {
                default: _withId(() => [
                  _createVNode(_component_m_icon, {
                    type: "trash",
                    class: "mr-2"
                  }),
                  _hoisted_57
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode("div", _hoisted_58, [
                _createVNode("div", _hoisted_59, [
                  _hoisted_60,
                  _createVNode("div", _hoisted_61, [
                    _withDirectives(_createVNode("select", {
                      "onUpdate:modelValue": ($event: any) => (schedule.weekday = $event),
                      class: "w-full border-b-2 border-gray-200 appearance-none pt-1 pb-2 px-3 focus:outline-none hover:border-primary-600 cursor-pointer"
                    }, [
                      _hoisted_62,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.weekdays, (weekday) => {
                        return (_openBlock(), _createBlock("option", {
                          key: weekday,
                          selected: schedule.weekday == weekday
                        }, _toDisplayString(weekday), 9, ["selected"]))
                      }), 128))
                    ], 8, ["onUpdate:modelValue"]), [
                      [_vModelSelect, schedule.weekday]
                    ]),
                    _hoisted_63
                  ])
                ]),
                _hoisted_64,
                _createVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _withDirectives(_createVNode("input", {
                    "onUpdate:modelValue": ($event: any) => (schedule.start = $event),
                    type: "time",
                    name: "start",
                    placeholder: "00:00",
                    class: "w-full border-b-2 border-gray-200 focus:border-primary-500 text-base outline-none text-gray-700 pb-1 px-3 leading-8 transition-colors duration-300"
                  }, null, 8, ["onUpdate:modelValue"]), [
                    [_vModelText, schedule.start]
                  ])
                ]),
                _hoisted_67,
                _createVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _withDirectives(_createVNode("input", {
                    "onUpdate:modelValue": ($event: any) => (schedule.end = $event),
                    type: "time",
                    name: "start",
                    placeholder: "00:00",
                    class: "w-full border-b-2 border-gray-200 focus:border-primary-500 text-base outline-none text-gray-700 pb-1 px-3 leading-8 transition-colors duration-300"
                  }, null, 8, ["onUpdate:modelValue"]), [
                    [_vModelText, schedule.end]
                  ])
                ])
              ])
            ]))
          }), 128)),
          _createVNode("div", {
            class: "flex items-center text-sm rounded-md text-gray-400 font-medium px-4 py-2 border-2 border-gray-200 cursor-pointer transition-colors duration-300 hover:text-primary-500 hover:border-primary-500",
            onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.addClassSchedule && _ctx.addClassSchedule(...args)))
          }, [
            _hoisted_70,
            _hoisted_71
          ])
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.propertyDatas, (data, i) => {
          return (_openBlock(), _createBlock("div", {
            key: data.property.ref.id,
            class: "relative w-3/4 mx-auto mb-6",
            style: { zIndex: _ctx.propertyDatas.length - i }
          }, [
            (data.property.data.type == 'string')
              ? (_openBlock(), _createBlock(_component_m_text_field, {
                  key: 0,
                  label: data.property.data.title,
                  name: data.property.ref.id,
                  type: "text",
                  placeholder: "テキストを入力",
                  value: data.value,
                  invalid: data.value.length == 0,
                  onInput: ($event: any) => (_ctx.propertyDatas[i].value = $event)
                }, null, 8, ["label", "name", "value", "invalid", "onInput"]))
              : (data.property.data.type == 'number')
                ? (_openBlock(), _createBlock(_component_m_text_field, {
                    key: 1,
                    label: data.property.data.title,
                    name: data.property.ref.id,
                    type: "number",
                    placeholder: "数字を入力",
                    value: data.value,
                    invalid: data.value.length == 0,
                    onInput: ($event: any) => (_ctx.propertyDatas[i].value = $event)
                  }, null, 8, ["label", "name", "value", "invalid", "onInput"]))
                : (
            data.property.data.type == 'select' && !data.property.data.multiple
          )
                  ? (_openBlock(), _createBlock(_component_m_select_box, {
                      key: 2,
                      label: data.property.data.title,
                      name: data.property.ref.id,
                      placeholder: "選択してください",
                      options: data.property.data.choices,
                      value: data.value,
                      onChange: ($event: any) => (_ctx.propertyDatas[i].value = $event)
                    }, null, 8, ["label", "name", "options", "value", "onChange"]))
                  : (
            data.property.data.type == 'select' && data.property.data.multiple
          )
                    ? (_openBlock(), _createBlock(_component_m_multi_select_box, {
                        key: 3,
                        label: data.property.data.title,
                        name: data.property.ref.id,
                        placeholder: 
            data.property.data.choices.filter(c =>
              (Array.isArray(data.value)
                ? data.value
                : [data.value.toString()]
              ).includes(c)
            ).length > 0
              ? data.property.data.choices
                  .filter(c =>
                    (Array.isArray(data.value)
                      ? data.value
                      : [data.value.toString()]
                    ).includes(c)
                  )
                  .join(', ')
              : '選択してください'
          ,
                        options: data.property.data.choices,
                        values: 
            Array.isArray(data.value) ? data.value : [data.value.toString()]
          ,
                        "force-scoped-id": "",
                        onChange: ($event: any) => (_ctx.updateMultiSelectValue(i, $event))
                      }, null, 8, ["label", "name", "placeholder", "options", "values", "onChange"]))
                    : _createCommentVNode("", true)
          ], 4))
        }), 128))
      ]),
      footer: _withId(() => [
        _createVNode(_component_m_button, {
          color: "red-400",
          "hover-color": "red-500",
          outline: "",
          class: "mr-4",
          onClick: _ctx.deleteStudent
        }, {
          default: _withId(() => [
            _hoisted_72
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.inRecess)
          ? (_openBlock(), _createBlock(_component_m_button, {
              key: 0,
              color: "secondary-500",
              "hover-color": "secondary-600",
              outline: "",
              class: "mr-4",
              onClick: _ctx.changeRecess
            }, {
              default: _withId(() => [
                _hoisted_73
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_m_button, {
              key: 1,
              color: "secondary-500",
              "hover-color": "secondary-600",
              outline: "",
              class: "mr-4",
              onClick: _ctx.changeRecess
            }, {
              default: _withId(() => [
                _hoisted_74
              ]),
              _: 1
            }, 8, ["onClick"])),
        _createVNode(_component_m_button, {
          color: "primary-500",
          "hover-color": "primary-600",
          disabled: !_ctx.validData,
          onClick: _ctx.update
        }, {
          default: _withId(() => [
            _hoisted_75
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _: 1
    }, 8, ["onClose"]),
    (_ctx.isDisplayQandaRegisterModal && _ctx.student)
      ? (_openBlock(), _createBlock(_component_MSQandaRegisterModal, {
          key: 0,
          student: _ctx.student,
          onQandaRegisterClose: _ctx.qandaRegisterModalClose
        }, null, 8, ["student", "onQandaRegisterClose"]))
      : _createCommentVNode("", true)
  ], 64))
})